var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-wrapper tenancy-other-contacts" },
    [
      _c("div", { staticClass: "table-caption" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("tenancy.table.allContacts")) + "\n  "),
      ]),
      _vm._v(" "),
      _vm.allowLinkContacts
        ? _c("div", { staticClass: "link__contact" }, [
            _c(
              "button",
              {
                staticClass: "btn link__contact--btn",
                attrs: { type: "button", disabled: !_vm.tenancyId },
                on: {
                  click: function ($event) {
                    return _vm.linkFunc({ isOthers: true })
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("tenancy.table.linkContact")))]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "link__contact--plus" }, [_vm._v("+")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c(
            "tr",
            [
              _vm._l(_vm.itemHeaders, function (header, index) {
                return _c("th", { key: index, class: header.class }, [
                  _vm._v(_vm._s(header.name)),
                ])
              }),
              _vm._v(" "),
              _c("th"),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.otherContacts, function (item, index) {
            return _c(
              "tr",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.enableEcircularFeature ||
                      !_vm.deep(item, "CompanyContact.isCircular") ||
                      _vm.deep(item, "CompanyContact.isEmergency"),
                    expression:
                      "enableEcircularFeature || (!deep(item, 'CompanyContact.isCircular') || deep(item, 'CompanyContact.isEmergency'))",
                  },
                ],
                key: index,
              },
              [
                _c("td", { staticClass: "number-column" }, [
                  _vm.canAccessContact
                    ? _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "name-hyper-link",
                            on: {
                              click: function ($event) {
                                return _vm.navToContactDetail(item.id, true)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.displayI18nFullName(
                                  item.firstName,
                                  item.lastName
                                ) || item.name
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isEngineer
                          ? _c("i", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !!item.remarks,
                                  expression: "!!item.remarks",
                                },
                              ],
                              staticClass: "remark-included-flag",
                            })
                          : _vm._e(),
                      ])
                    : _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.displayI18nFullName(
                                item.firstName,
                                item.lastName
                              ) || item.name
                            ) +
                            "\n          "
                        ),
                      ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm._f("isEmptyValue")(
                        _vm.deep(item, "CompanyContact.title")
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm._f("isEmptyValue")(item.phone)))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm._f("isEmptyValue")(item.email)))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.calcContactRoleType(item)))]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _vm._l(_vm.remarksFieldMap, function (mapItem, mapIndex) {
                      return [
                        mapItem.shouldShow(item)
                          ? _c("TextField", {
                              directives: [
                                { name: "hkldinput", rawName: "v-hkldinput" },
                              ],
                              key: mapIndex,
                              attrs: {
                                parentNode: "",
                                value: mapItem.componentVal(item),
                                disabled: mapItem.shouldDisable(),
                                readonly: !_vm.allowLinkContacts,
                              },
                              on: {
                                updateValue: function (val) {
                                  return mapItem.updateValueFn(index, val)
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("td", { staticClass: "icon-remove" }, [
                  _vm.allowLinkContacts
                    ? _c("i", {
                        staticClass: "fa fa-times-thin",
                        on: {
                          click: function ($event) {
                            return _vm.openDeleteConfirm(index, item)
                          },
                        },
                      })
                    : _vm._e(),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "deleteConfirmModal",
        attrs: {
          modalId: _vm.delConfModalId,
          confirmTitle: _vm.$t("deleteConfirmMsg"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }